var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74271 1V2.49602L4.66048 3.06897L3.19629 2.0504L2.08223 3.48276L2.94164 4.88329L2.30504 6.06101H1V8.00265L2.59151 8.28912L2.94164 9.14854L2.08223 10.6446L3.4191 11.7905L4.66048 10.8992L5.74271 11.5358L5.93369 13H7.81167L8.12997 11.122L9.08488 10.6446L10.6446 11.7905L11.6313 10.6446L10.6446 9.14854L11.1857 8.00265L12.7772 7.77984V6.06101L10.9629 5.80637L10.6446 4.69231L11.6313 3.48276L10.3899 2.0504L8.83024 3.06897L7.81167 2.49602V1H5.74271Z",
    stroke: "#2E77D0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.72944,
    cy: 7.0163,
    r: 2.26923,
    stroke: "#2E77D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.536ab55668b8967528263cbfe4eeaa37.svg";
export { ForwardRef as ReactComponent };